import { gql } from '@apollo/client';

export const MAINTENANCES_QUERY = gql`
  query MaintenancesQuery {
    maintenances {
      id
      startDate
      endDate
    }
  }
`;
